import { get, set, omit } from 'lodash';
import { createContext, useContext, useState, useEffect, useMemo } from 'react';

const SortableListContext = createContext();

export const SortableListProvider = ({ children, listIds }) => {
  const [itemsOpen, setItemsOpen] = useState({});

  const instantiateItemsOpen = (listIds) => {
    const initialItems = itemsOpen;

    listIds.forEach((id) => {
      if (!get(initialItems, id)) {
        set(initialItems, id, false);
      }
    });

    setItemsOpen((prevState) => ({ ...prevState, ...initialItems }));
  };

  const updateItemOpen = (id, bool) => {
    setItemsOpen((prevState) => ({ ...prevState, [id]: bool }));
  };

  const removeItemOpen = (id) => {
    setItemsOpen((prevState) => omit(prevState, id));
  };

  const isItemOpen = (id) => get(itemsOpen, id);

  const areAllItemsClosed = useMemo(
    () => Object.values(itemsOpen).every((element) => element === false),
    [itemsOpen],
  );

  useEffect(() => {
    instantiateItemsOpen(listIds);
  }, [listIds]);

  const value = useMemo(
    () => ({
      itemsOpen,
      allItemsClosed: areAllItemsClosed,
      isItemOpen,
      updateItemOpen,
      removeItemOpen,
    }),
    [itemsOpen],
  );

  return (
    <SortableListContext.Provider value={value}>
      {children}
    </SortableListContext.Provider>
  );
};

export const useSortableListContext = () => useContext(SortableListContext);
